import { render, staticRenderFns } from "./ConciergeTopIndex.vue?vue&type=template&id=2f84b48f&scoped=true"
import script from "./ConciergeTopIndex.vue?vue&type=script&lang=js"
export * from "./ConciergeTopIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f84b48f",
  null
  
)

export default component.exports